import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { faSearch, IconDefinition } from '@fortawesome/pro-duotone-svg-icons';
import { Observable } from 'rxjs';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';

@Component({
   selector: 'samweb-searchbar',
   templateUrl: './searchbar.component.html',
   styleUrls: ['./searchbar.component.scss'],
})
export class SearchbarComponent implements OnInit {
   constructor() {}

   public searchIcon: IconDefinition = faSearch;
   public clearFilterIcon: IconDefinition = WellKnownIconsEnum.CLEAR.iconSmall;

   @Input()
   searchText = 'common.search-text';

   @Input()
   searchValue$: Observable<string>;

   @Output()
   public searchValueChanged = new EventEmitter();

   @Output()
   public searchValueChangedDebounced = new EventEmitter();

   ngOnInit(): void {}

   searchTextChanged(value: string) {
      this.searchValueChanged.emit(value);
   }

   searchTextChangedDebounced(value: string) {
      this.searchValueChangedDebounced.emit(value);
   }

   clearSearchText() {
      this.searchValueChanged.emit('');
      this.searchValueChangedDebounced.emit('');
   }
}
